import apiClient from '../middleware/apiClient';
import { SSM_XM_ESTIMATED, COTTON_SSM_XM_ESTIMATED } from '../helpers/apis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_XM_ESTIMATED = 'GET_XM_ESTIMATED';
export const GET_XM_ESTIMATED_SUCCESS = 'GET_XM_ESTIMATED_SUCCESS';
export const GET_XM_ESTIMATED_FAILURE = 'GET_XM_ESTIMATED_FAILURE';

/**
 * Dispatches GET_XM_ESTIMATED action with API payload.
 */
function dispatchGetXmEstimated(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_SSM_XM_ESTIMATED : SSM_XM_ESTIMATED;
  return {
    type: GET_XM_ESTIMATED,
    payload: apiClient.fetch(endpoint),
  };
}

/**
 * Dispatches GET_XM_ESTIMATED_SUCCESS action with required fields for confirmation page.
 */
export function dispatchGetXmEstimatedSuccess(details) {
  return {
    type: GET_XM_ESTIMATED_SUCCESS,
    payload: {
      autoPayDate: details.message.autoPayDate,
      cycleTotal: details.message.cycleTotal,
    },
  };
}

/**
 * Dispatches GET_XM_ESTIMATED_FAILURE action.
 */
function dispatchGetXmEstimatedError(error) {
  return {
    type: GET_XM_ESTIMATED_FAILURE,
    payload: error,
  };
}

/**
 * Thunk to fetch xmEstimated autopay confirmation details.
 */
export const getXmEstimated = () => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchGetXmEstimated(isCottonSession)).payload;
    return dispatch(dispatchGetXmEstimatedSuccess(response));
  } catch (error) {
    dispatch(dispatchGetXmEstimatedError(error));
    throw error;
  }
};
